import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取缴费类型总列表
  billCategoryAllList(data) {
    const params = data
    return request({
      url: urlParams + '/bill-category/totalList',
      type: 'get',
      params: params
    })
  },     
  // 获取缴费类型列表
  billCategoryList(data) {
    const params = data
    return request({
      url: urlParams + '/bill-category/list',
      type: 'get',
      params: params
    })
  },   
  // 获取缴费类型添加修改
  billCategoryAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/bill-category/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  // 获取缴费类型删除
  billCategoryDel(data) {
    const params = data
    return request({
      url: urlParams + '/bill-category/del',
      type: 'post',
      params: params
    })
  },  
  // 获取未缴费记录列表
  billNotPayList(data) {
    const params = data
    return request({
      url: urlParams + '/bill/notPayList',
      type: 'get',
      params: params
    })
  },   
  // 获取缴费记录列表
  billList(data) {
    const params = data
    return request({
      url: urlParams + '/bill/list',
      type: 'get',
      params: params
    })
  },  
  // 缴费记录删除
  billDel(data) {
    const params = data
    return request({
      url: urlParams + '/bill/del',
      type: 'post',
      params: params
    })
  },   
  // 批量生成账单
  billBatchCreateBill(data) {
    const params = data
    return request({
      url: urlParams + '/bill/batchCreateBill',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  billCreateBillRidgepole(data) {
    const params = data
    return request({
      url: urlParams + '/bill/createBillRidgepole',
      type: 'post',
      params: params,
      qs:false
    })
  }, 
  
  billCreateBillRoom(data) {
    const params = data
    return request({
      url: urlParams + '/bill/createBillRoom',
      type: 'post',
      params: params,
      qs:false
    })
  },
  
  // 获取账单模板总列表  
  billTemplateAllList(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template/totalList',
      type: 'get',
      params: params
    })
  },   
  // 获取账单模板列表  
  billTemplateList(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template/list',
      type: 'get',
      params: params
    })
  },   
  // 获取账单模板添加修改  
  billTemplateAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 获取账单模板删除
  billTemplateDel(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template/del',
      type: 'post',
      params: params
    })
  },    
  // 获取账单模板类型管理
  billTemplateCategoryList(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template-category/list',
      type: 'get',
      params: params
    })
  },    
  // 获取账单模板类型添加修改
  billTemplateCategoryAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template-category/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 获取账单模板类型删除
  billTemplateCategoryDel(data) {
    const params = data
    return request({
      url: urlParams + '/bill-template-category/del',
      type: 'post',
      params: params
    })
  },   
  // 导入账单模板
  billImportCreateBill(data) {
    const params = data
    return request({
      url: urlParams + '/bill/importCreateBill',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 账单核销
  billWriteOff(data) {
    const params = data
    return request({
      url: urlParams + '/bill/writeOff',
      type: 'post',
      params: params
    })
  },  
  // 资金日报表
  billMonthReportForm(data) {
    const params = data
    return request({
      url: urlParams + '/bill/monthReportForm',
      type: 'get',
      params: params
    })
  },   
  // 临时账单列表
  billTemporaryList(data) {
    const params = data
    return request({
      url: urlParams + '/bill-temporary/list',
      type: 'get',
      params: params
    })
  },   
  // 临时账单新增修改
  billTemporaryAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/bill-temporary/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
  // 临时账单删除
  billTemporaryDel(data) {
    const params = data
    return request({
      url: urlParams + '/bill-temporary/del',
      type: 'post',
      params: params
    })
  },  
  // 临时账单核销
  billTemporaryWriteOff(data) {
    const params = data
    return request({
      url: urlParams + '/bill-temporary/writeOff',
      type: 'post',
      params: params
    })
  },   
  // 资金日报表
  billDayReportForm(data) {
    const params = data
    return request({
      url: urlParams + '/bill/dayReportForm',
      type: 'get',
      params: params
    })
  },   
  // 审核
  billVerify(data) {
    const params = data
    return request({
      url: urlParams + '/bill/verify',
      type: 'post',
      params: params
    })
  },   
  // 账单修改
  billUp(data) {
    const params = data
    return request({
      url: urlParams + '/bill/up',
      type: 'post',
      params: params
    })
  },  
  // 发送缴费通知
  sendBill(data) {
    const params = data
    return request({
      url: urlParams + '/send-message/bill',
      type: 'post',
      params: params
    })
  },                       
}